/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  loginHeading: () => _t(translations.loginHeading, 'Login'),
  corporateIdPlaceholder: () =>
    _t(translations.corporateIdPlaceholder, 'Corporate ID'),
  userIdPlaceholder: () => _t(translations.userIdPlaceholder, 'User ID'),
  passwordPlaceholder: () => _t(translations.passwordPlaceholder, 'Password'),
  loginButtonLabel: () => _t(translations.loginButtonLabel, 'Login'),
  rememberMeLabel: () => _t(translations.rememberMeLabel, 'Remember Me'),

  forgetPasswordLabel: () =>
    _t(translations.forgetPasswordLabel, 'Forgot Password?'),
  invalid_grant: () =>
    _t(
      translations.invalid_grant,
      'Invalid Credentials. User is not registered.',
    ),
  invalid_grant_count: () =>
    _t(
      translations.invalid_grant_count,
      'Invalid Credentials. Attempts remaining: {{}}',
    ),
  invalid_grant_lock: () =>
    _t(
      translations.invalid_grant_lock,
      'Account locked. Your account has been locked due to 5 failed attempts. To unlock, click on the “Forgot password"',
    ),
};
